import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper, Slider } from '@material-ui/core';
import { Flex, Typography } from '@knockrentals/knock-shared-web-v2';
import { TabSectionHeader } from '../../TabSections';
import { makeCss } from '../../../../../../../knock-design-system';

export const REFERRAL_RADIUS_TITLE = 'Referral Radius';
export const REFERRAL_RADIUS_DESCRIPTION =
  'Properties within this distance will be eligible for referrals (default 20 mi).';

const CROSS_SELL_RADIUS_MAX = 50;
const CROSS_SELL_RADIUS_MIN = 0;

const DISTANCE_UNITS = {
  KM: 'kilometers',
  MI: 'miles',
};

const DISTANCE_UNIT_LABELS = {
  [DISTANCE_UNITS.KM]: 'km',
  [DISTANCE_UNITS.MI]: 'mi',
};

const SLIDER_MARKS = {
  [DISTANCE_UNITS.KM]: [
    {
      label: `0 ${DISTANCE_UNIT_LABELS[DISTANCE_UNITS.KM]}`,
      value: 0,
    },
    {
      label: `30 ${DISTANCE_UNIT_LABELS[DISTANCE_UNITS.KM]}`,
      value: 30,
    },
    {
      label: `80 ${DISTANCE_UNIT_LABELS[DISTANCE_UNITS.KM]}`,
      value: 80,
    },
  ],
  [DISTANCE_UNITS.MI]: [
    {
      label: `0 ${DISTANCE_UNIT_LABELS[DISTANCE_UNITS.MI]}`,
      value: 0,
    },
    {
      label: `20 ${DISTANCE_UNIT_LABELS[DISTANCE_UNITS.MI]}`,
      value: 20,
    },
    {
      label: `50 ${DISTANCE_UNIT_LABELS[DISTANCE_UNITS.MI]}`,
      value: 50,
    },
  ],
};

const useCss = makeCss({
  rangeWrapper: {
    width: '162px',
    padding: '4px 16px',
  },
});

const ReferralRadius = ({
  propertyCount,
  radius,
  setRadius,
  sliderDistanceUnit = DISTANCE_UNITS.MI,
}) => {
  const css = useCss();
  const [referralRadius, setReferralRadius] = useState(radius);

  return (
    <Flex flexDirection="column" gap={16}>
      <TabSectionHeader
        description={REFERRAL_RADIUS_DESCRIPTION}
        title={REFERRAL_RADIUS_TITLE}
      />

      <Flex alignItems="center" gap={40} justifyContent="space-between">
        <Slider
          marks={SLIDER_MARKS[sliderDistanceUnit]}
          max={CROSS_SELL_RADIUS_MAX}
          min={CROSS_SELL_RADIUS_MIN}
          onChangeCommitted={(e, value) => setRadius(value)}
          onChange={(_e, value) => setReferralRadius(value)}
          step={10}
          value={referralRadius}
        />

        <Paper css={css.rangeWrapper} variant="outlined">
          <Typography variant="caption" color="textSecondary" align="center">
            Properties in range
          </Typography>
          <Typography variant="body2" color="textSecondary" align="center">
            {propertyCount}
          </Typography>
        </Paper>
      </Flex>
    </Flex>
  );
};

ReferralRadius.propTypes = {
  propertyCount: PropTypes.number,
  radius: PropTypes.number,
  setRadius: PropTypes.func,
  sliderDistanceUnit: PropTypes.string,
};

export default ReferralRadius;
